module.exports = {
	"newsletter": {
		"orderTitle": "Tilaa uutiskirje",
		"title": "Uutiskirje",
		"text": "Tilaamalla uutiskirjeemme kuulet ensimmäisten joukossa ajankohtaisia kuulumisiamme sekä lisätietoja tulevista tapahtumistamme.",
		"private": "Olen yksityisasiakas",
		"business": "Olen yritysasiakas",
		"placeholder": "Sähköpostiosoitteesi",
		"submit": "Tilaa",
		"success": "Kiitos! Tilauksesi on vastaanotettu.",
		"fail": "Uutiskirjeen tilaaminen epäonnistui.",
		"tryAgain": "Yritä uudelleen"
	},
	"footer": {
		"openTitle": "Aukioloajat",
		"specialHours": "Poikkeusaukioloajat",
		"privacyPolicy": "Asiakasrekisterin tietosuojaseloste",
		"webshopPrivacyPolicy": "B2B suoramarkkinoinnin tietosuojaseloste",
		"webshopTerms": "Verkkokaupan toimitusehdot",
		"otherTimes": "Muutoin avoinna sopimuksen mukaan"
	},
	"contact": {
		"onlineInvoices": "Verkkolaskut"
	},
	"contactForm": {
		"heading": "Ota yhteyttä",
		"description": "Voit olla meihin yhteydessä suoraan sähköpostitse, puhelimitse tai täyttämällä oheisen lomakkeen. Saatuamme yhteydenottopyyntönne palaamme teille mahdollisimman pian asiaan!",
		"success": "Kiitos! Viestisi on vastaanotettu.",
		"fail": "Lähetys epäonnistui. Yritä hetken päästä uudelleen!",
		"name": "Nimi",
		"email": "Sähköpostiosoite",
		"phone": "Puhelinnumero",
		"message": "Viesti",
		"restaurant": "Valitse leipomo-ravintola",
		"submit": "Lähetä"
	},
	"header": {
		"foodAndDrinks": "Ruoka ja juoma",
		"contactUs": "Yhteystiedot"
	},
	"general": {
		"loadMore": "Lataa lisää",
		"giftBtn": "Lahjaksi",
		"bookTable": "Varaa pöytä",
		"bookTableHeader": "Varaa pöytä",
		"bookOnline": "Tee pöytävaraus\n(1-12 henkilöä)",
		"bookFormBtn": "Tee varauspyyntö\n(yli 12 henkilöä)",
		"bookOnlinePunavuori": "Onlinevaraus Punavuori",
		"bookOnlineToolo": "Onlinevaraus Töölö",
		"businessCard": "Tilaa yrityskortti",
		"giftCard": "Osta lahjakortti",
		"forMedia": "Medialle",
		"sendRequest": "Lähetä tiedustelu",
		"oiva": "Oiva-raportti"
	},
	"offerForm": {
		"heading": "Tarjouspyyntö",
		"description": "Olethan meihin yhteydessä niin suunnitellaan teille yhdessä ikimuistoisen tilaisuus! Tarjouspyynnön voit jättää alla olevalla lomakkeella tai sähköpostitse sales@w-restaurants.fi.",
		"premisesHeading": "Kuvaus tiloista",
		"premisesDescription": "Jätä tähän lyhyt kuvaus tiloista ja keittiöstä, kuten onko tapahtumapaikalla hellaa, uunia, jääkaappia, pakastinta tai laskutilaa.",
		"dishesHeading": "Tarvitaanko astiat?",
		"dishesYes": "Kyllä",
		"dishesNo": "Ei",
		"activityHeading": "Ohjelmapalvelut",
		"activityDescription": "Toteutamme mielellämme mukavaa ja rentoa ohjelmaa tärkeisiin hetkiinne. Kyseessä voi olla esimerkiksi viini- tai sake-tasting pikkujoulujen aluksi tai cocktail-koulu polttariseurueelle. Voit tutustua ohjelmapalveluihimme tarkemmin",
		"activityCocktailSchool": "Cocktail-koulu",
		"activitySakeTasting": "Sake-tasting",
		"activityWineTasting": "Viini-tasting",
		"budget": "Alustava budjetti",
		"name": "Nimi",
		"company": "Yritys",
		"email": "Sähköpostiosoite",
		"phone": "Puhelinnumero",
		"date": "Päivä",
		"location": "Paikka",
		"time": "Klo",
		"people": "Henkilömäärä",
		"serviceType": "Toivottu tarjoilutapa",
		"serviceTypeCocktail": "Cocktail-tilaisuus tarjottimilta",
		"serviceTypeBuffet": "Buffet",
		"serviceTypeDinner": "Istuva illallinen",
		"eventType": "Tilaisuuden luonne",
		"submit": "Lähetä",
		"success": "Kiitos tarjouspyynnöstä, palaamme asiaan mahdollisimman pian!",
		"fail": "Lähetys epäonnistui. Tarkista että täytit kaikki pakolliset kentät ja yritä hetken päästä uudelleen!"
	},
	"groupReservation": {
		"heading": "Pöytävaraustiedustelu yli 10 hengen seurueille",
		"date": "Päivämäärä *",
		"time": "Kellonaika (klo: 15:00-22:00)",
		"people": "Henkilömäärä",
		"wishes": "Toiveet",
		"name": "Nimi",
		"email": "Sähköpostiosoite",
		"phone": "Puhelinnumero",
		"billing": "Laskutustiedot ja Y-tunnus",
		"notice": "Huomioittehan, että varaus on voimassa vasta, kun se on vahvistettu sähköpostitse tai puhelimitse. Laskutus on mahdollinen vain yrityksille tai yhteisölle, vahvistamme laskutusmahdollisuuden varauksen vahvistamisen yhteydessä. Laskun loppusummaan lisätään laskutuslisä 15 €.",
		"success": "Kiitos tiedustelusta, palaamme asiaan mahdollisimman pian! Huomioittehan, että varaus on voimassa vasta, kun se on vahvistettu sähköpostitse tai puhelimitse.",
		"fail": "Lähetys epäonnistui. Tarkista että täytit kaikki pakolliset kentät ja yritä hetken päästä uudelleen!"
	},
	"shoppingCart": {
		"heading": "Ostoskorisi",
		"emptyCart": "Ostoskorisi on tyhjä",
		"totalPrice": "Loppusumma",
		"checkout": "Siirry maksamaan"
	},
	"webshop": {
		"addToCart": "Lisää ostoskoriin",
		"chooseValue": "Valitse lahjakortin arvo"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/lang/fi.json
// module id = 1065
// module chunks = 0